import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const useEmployeeIdColumn = () => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => {
    const employee = params.data?.employee;
    return employee?.identification || employee?.employeeIdField || '';
  }, []);

  return useMemo(
    () => ({
      field: 'employee',
      headerName: t('employeeIdField'),
      width: 150,
      cellClass: 'justify-start',
      valueGetter
    }),
    [t, valueGetter]
  );
};

export default useEmployeeIdColumn;
